const isCurrentTimeBetweenHours = (startHour: number, endHour: number) => {
  const currentHour = new Date(Date.now()).getHours();
  if (currentHour >= startHour && currentHour < endHour) return true;
  return false;
};

export { isCurrentTimeBetweenHours };
